import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "./Logo";
import { trackCTAClick } from "@/lib/analytics";

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="border-t border-gray-100 bg-white py-12"
    >
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 px-6 lg:flex-row lg:px-8">
            <div className="flex flex-col items-center gap-2 lg:items-start">
                <Logo />
                <p className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">
                    Grow&nbsp;&nbsp;|&nbsp;&nbsp;Convert&nbsp;&nbsp;|&nbsp;&nbsp;Get Paid
                </p>
                <p className="mt-3 text-sm text-[#4B5563]">
                    Email:{" "}
                    <a
                        href="mailto:admin@flowpilotops.co.uk"
                        data-testid="footer-email-link"
                        className="font-medium text-[#2563EB] transition-colors hover:text-blue-700"
                    >
                        admin@flowpilotops.co.uk
                    </a>
                </p>
            </div>
            <nav className="flex items-center gap-6">
                <a
                    href="#how-it-works"
                    data-testid="footer-how-it-works"
                    className="text-sm text-[#4B5563] transition-colors hover:text-[#0B1F44]"
                >
                    How It Works
                </a>
                <a
                    href="#pricing"
                    data-testid="footer-pricing"
                    className="text-sm text-[#4B5563] transition-colors hover:text-[#0B1F44]"
                >
                    Pricing
                </a>
                <a
                    href="#growth-review"
                    data-testid="footer-growth-review"
                    className="text-sm text-[#4B5563] transition-colors hover:text-[#0B1F44]"
                >
                    Growth Review
                </a>
                <Link
                    to="/privacy"
                    data-testid="footer-privacy"
                    className="text-sm text-[#4B5563] transition-colors hover:text-[#0B1F44]"
                >
                    Privacy Policy
                </Link>
                <Link
                    to="/terms"
                    data-testid="footer-terms"
                    className="text-sm text-[#4B5563] transition-colors hover:text-[#0B1F44]"
                >
                    Terms of Service
                </Link>
            </nav>
            <a
                href="#growth-review"
                data-testid="footer-cta-button"
                onClick={() => trackCTAClick("footer")}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#2563EB] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
            >
                Book a 20-minute Growth Review
                <ArrowRight className="h-4 w-4" />
            </a>
        </div>
        <div className="mx-auto mt-8 max-w-7xl px-6 lg:px-8">
            <p className="text-center text-xs text-[#9CA3AF] lg:text-left">
                &copy; {new Date().getFullYear()} FlowPilot. All rights
                reserved.
            </p>
        </div>
    </footer>
);
